import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors } from 'builder/modules/init'

export const useNetworkStatus = () => useTypedSelector(selectors.isOnline)
